import { IErrorResponseType, ISubmitPaymentConsent, ISuccessResponseType } from "../../constants/commonTypes"
import { IAccountType } from "../reducers/transactionDetailsReducer"
import { TransactionState } from "../reducers/transactionDetailsReducer"

export const GET_TRANSACTION_DETAILS = "GET_TRANSACTION_DETAILS"
export const GET_TRANSACTION_DETAILS_REQUEST = "GET_TRANSACTION_DETAILS_REQUEST"
export const GET_TRANSACTION_DETAILS_SUCCESS = "GET_TRANSACTION_DETAILS_SUCCESS"
export const GET_TRANSACTION_DETAILS_FAILURE = "GET_TRANSACTION_DETAILS_FAILURE"

export const SUBMIT_TRANSACTION_CONSENT = "SUBMIT_TRANSACTION_CONSENT"
export const SUBMIT_TRANSACTION_CONSENT_REQUEST = "SUBMIT_TRANSACTION_CONSENT_REQUEST"
export const SUBMIT_TRANSACTION_CONSENT_SUCCESS = "SUBMIT_TRANSACTION_CONSENT_SUCCESS"
export const SUBMIT_TRANSACTION_CONSENT_FAILURE = "SUBMIT_TRANSACTION_CONSENT_FAILURE"
export const SUBMIT_TRANSACTION_CONSENT_RESET = "SUBMIT_TRANSACTION_CONSENT_RESET"

export const GET_TAX_DETAILS = "GET_TAX_DETAILS"
export const GET_TAX_DETAILS_REQUEST = "GET_TAX_DETAILS_REQUEST"
export const GET_TAX_DETAILS_SUCCESS = "GET_TAX_DETAILS_SUCCESS"
export const GET_TAX_DETAILS_FAILURE = "GET_TAX_DETAILS_FAILURE"
export const GET_UPDATE_SUCCESS = "GET_UPDATE_SUCCESS"
export const GET_UPLOAD_DETAILS = "GET_UPLOAD_DETAILS"



// Get Transaction Details
export interface GetTransactionDetailsAction {
  type: typeof GET_TRANSACTION_DETAILS;
}

export interface GetTransactionDetailsRequestAction {
  type: typeof GET_TRANSACTION_DETAILS_REQUEST;
}

export interface GetTransactionDetailsSuccessAction {
  type: typeof GET_TRANSACTION_DETAILS_SUCCESS;
  userName: string;
  userDOB: string;
  pan: string;
  freezeFlag: boolean;
  emailId: string;
  amount: number;
  currency: string;
  referenceNumber: string;
  purposeCode: string;
  limit: number;
  partnerName: string;
  accNumbers: Array<IAccountType>;
  transactionDetailsFetched: boolean;
  lastLoginTime: string;
}

export interface GetTransactionDetailsFailureAction {
  type: typeof GET_TRANSACTION_DETAILS_FAILURE;
  error: Error | string | null | IErrorResponseType;
}



// Submit Transaction Consent
export interface SubmitTransactionConsentAction {
  type: typeof SUBMIT_TRANSACTION_CONSENT;
  request: ISubmitPaymentConsent;
}

export interface SubmitTransactionConsentRequestAction {
  type: typeof SUBMIT_TRANSACTION_CONSENT_REQUEST;
}

export interface SubmitTransactionConsentSuccessAction {
  type: typeof SUBMIT_TRANSACTION_CONSENT_SUCCESS;
  consentResponse: ISuccessResponseType;
}

export interface SubmitTransactionConsentFailureAction {
  type: typeof SUBMIT_TRANSACTION_CONSENT_FAILURE;
  error: Error | string | null | IErrorResponseType;
}

export interface SubmitTransactionConsentResetAction {
  type: typeof SUBMIT_TRANSACTION_CONSENT_RESET;
}

export interface GetTaxAction {
  type: typeof GET_TAX_DETAILS;
}

export interface GetUploadAction {
  type: typeof GET_UPLOAD_DETAILS;
}

export interface GetTaxRequestAction {
  type: typeof GET_TAX_DETAILS_REQUEST;
}

export interface GetTaxSuccessAction {
  type: typeof GET_TAX_DETAILS_SUCCESS;
  response: TransactionState;
}

export interface GetUploadSuccessAction {
  type: typeof GET_UPDATE_SUCCESS;
  response: TransactionState;
}

export interface GetTaxFailureAction {
  type: typeof GET_TAX_DETAILS_FAILURE;
  error: Error | string | null | IErrorResponseType;
}




export type TransactionAction =
  | GetTransactionDetailsAction
  | GetTransactionDetailsRequestAction
  | GetTransactionDetailsSuccessAction
  | GetTransactionDetailsFailureAction

  | SubmitTransactionConsentAction
  | SubmitTransactionConsentRequestAction
  | SubmitTransactionConsentSuccessAction
  | SubmitTransactionConsentFailureAction
  | SubmitTransactionConsentResetAction

  | GetUploadAction
  | GetTaxAction
  | GetTaxRequestAction
  | GetTaxSuccessAction
  | GetUploadSuccessAction
  | GetTaxFailureAction;
